var React = require('react');

function PaymentOptionAuspost (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(-22 -22)"},[React.createElement("path",{"d":"m77 74.9c0 1.1-1 2.1-2.1 2.1h-50.8c-1.1 0-2.1-.9-2.1-2.1v-50.8c0-1.2 1-2.1 2.1-2.1h50.7c1.2 0 2.1.9 2.2 2.1z","fill":"#000","fillRule":"nonzero","key":0}),React.createElement("path",{"d":"m0 0h98v98h-98z","opacity":".4","key":1}),React.createElement("path",{"d":"m31.8 49.4c0 7.4 4.8 13.7 11.5 16.2v-32.4c-6.8 2.5-11.5 8.9-11.5 16.2m17.8-17.3c-.5 0-1 0-1.4.1v1.2h.1c6.8.1 12.2 5.1 12.2 11.2-.1 6.1-5.6 11.1-12.3 11.1v11h1.4c9.8 0 17.8-7.7 17.8-17.3-.1-9.5-8.1-17.3-17.8-17.3","fill":"#fff","fillRule":"nonzero","key":2})]));
}

PaymentOptionAuspost.defaultProps = {"height":"55","viewBox":"0 0 55 55","width":"55"};

module.exports = PaymentOptionAuspost;

PaymentOptionAuspost.default = PaymentOptionAuspost;
